import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
/**
 * Helper for removing an item from an array if it exists, or adding it if it doesn't exist.
 */
export var toggleArrayValue = function toggleArrayValue(values, value) {
  var index = values.indexOf(value);
  var nextValues = _toConsumableArray(values);
  if (index >= 0) {
    nextValues.splice(index, 1);
  } else {
    nextValues.push(value);
  }
  return nextValues;
};